// extracted by mini-css-extract-plugin
module.exports = {"selectedIcon":"style_selectedIcon__1c0uB","buttons":"style_buttons__2VPsF"};